module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1270.1e021327.png";